import React from 'react';

const SubscriptionLink = (props) => {
  const { LinkText, LinkUrl } = props;

  if (!LinkText || !LinkUrl) return null;

  return (
    <a className="subscription-link" href={LinkUrl}>
      <span>{LinkText}</span>
      <i className="subscription-link__chevron"></i>
    </a>
  );
};

export default SubscriptionLink;
